import ApartmentMomentAtd from '../../features/apartment/ApartmentMomentAtd'

const ApartmentMomentAtdPage = () => {
  return (
  <ApartmentMomentAtd/> 
  )
}

export default ApartmentMomentAtdPage